  /**
   * Preferencia UI: auto-prefetch de related_studies.
   * v1: solo persiste el toggle. Motor real = P-RELATED-STUDIES-V2 (pendiente).
   * @see docs/CONTRATO-VIEWER-TICKETS.md
   */

export const RELATED_STUDIES_PREFETCH_KEY = 'udv.relatedStudies.prefetch'

/**
 * @returns {boolean} default false (on-demand)
 */
export function loadRelatedStudiesPrefetchPref() {
  try {
    if (typeof localStorage === 'undefined') return false
    const v = localStorage.getItem(RELATED_STUDIES_PREFETCH_KEY)
    if (v == null || v === '') return false
    return v === '1' || v === 'true' || v === 'on'
  } catch (e) {
    return false
  }
}

/**
 * @param {boolean} enabled
 */
export function saveRelatedStudiesPrefetchPref(enabled) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.setItem(
      RELATED_STUDIES_PREFETCH_KEY,
      enabled ? '1' : '0'
    )
  } catch (e) {
    /* ignore */
  }
}
